var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImentorGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#1373E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1362 33L7 26.9246L12.8638 6L33 12.0754L27.1362 33ZM10.0437 25.1913L25.4854 29.8551L29.9735 13.8087L14.5317 9.14494L10.0437 25.1913Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18C21.1262 18 22 18.7676 22 19.7569C22 20.7463 21.1262 21.5139 20 21.5139C18.8738 21.5139 18 20.7463 18 19.7569C18.0194 18.7676 18.8932 18 20 18ZM18.6214 22.7591H21.3786V34H18.6214V22.7591Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImentorGroup);
export default __webpack_public_path__ + "static/media/imentor_group.b5ca078b0c7c0d6a14b11832c72999d0.svg";
export { ForwardRef as ReactComponent };